import React from 'react'
import PropTypes from 'prop-types'
import withStickiness from 'shared/hocs/withStickiness'
import { CSSTransition } from 'react-transition-group'
import { OpenedCard, ClosedCard } from './cards'
import { CONTACT_DETAILS_CLASS } from './ContactDetails'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'
import { ACCESSIBILITY_CLASSES, TAB_INDEXES, isEnterKey } from 'shared/helpers/AccessibilityHelper'
import get from 'lodash/get'

import './style.css.scss'

const SENSITIVITY_FACTOR = 5

class SellerCard extends React.Component {
  constructor(props) {
    super(props)
    this.container = null
    this.state = {
      width: 'auto',
      contactDetailsHeight: 0,
      isOpen: true,
      isCtaOpen: false
    }
  }

  componentDidMount() {
    const { isGreetingOpen, provideStickyContainer } = this.props

    provideStickyContainer(this.container)
    !isGreetingOpen && this.setCloseTimeout()
    this.handleSellerCardWidth()
  }

  componentWillUnmount() {
    this.props.provideStickyContainer(null)
    clearTimeout(this.closeCardTimeout)
    clearTimeout(this.sellerCardWidthTimeout)
  }

  setCloseTimeout = () => {
    this.closeCardTimeout = setTimeout(this.closeSellerCard, 3000)
  }

  handleScroll = () => {
    const rect = this.container.getBoundingClientRect()
    if (rect.top + rect.height < 0) {
      this.closeSellerCard()
    }
  }

  handleSellerCardWidth = () => {
    // this is a patch in order to set the width after css applied
    this.sellerCardWidthTimeout = setTimeout(() => {
      if(this.state.width == 'auto') {
        this.setState({ width: this.container.offsetWidth + SENSITIVITY_FACTOR })
      }
    }, 0)
  }

  getContactDetailsHeight = () => {
    const contactDetails = document.getElementsByClassName(CONTACT_DETAILS_CLASS)[0]
    return !!contactDetails ? contactDetails.clientHeight - SENSITIVITY_FACTOR : 0
  }

  openSellerCard = () => this.setState({isOpen: true})
  closeSellerCard = () => {
    if(this.state.isOpen && !this.state.isCtaOpen) {
      this.setState({isOpen: false})
    }
  }

  handleCtaOpen = () => {
    this.setState({isCtaOpen: true})
    clearTimeout(this.closeCardTimeout)
  }

  handleCtaClose = () => this.setState({isCtaOpen: false, isOpen: false})

  // in order for the seller-card-container to receive it's real height
  // the open/close animation has to be with margin-top.
  // since the contact details height is dynamic it has to be calculated in the JS
  handleOpenCardEntered = () => this.setState({contactDetailsHeight: 0})
  handleOpenCardExiting = () => {
    this.setState({contactDetailsHeight: this.getContactDetailsHeight()})
  }

  onKeyboardClick = (e) => {
    if (isEnterKey(e)) {
      if (!this.state.isOpen) {
        this.openSellerCard(e)
      } else {
        this.closeSellerCard(e)
      }
    }
  }

  render() {
    const { isOpen, width, contactDetailsHeight } = this.state
    const { config, lead, themeColorHex, seller } = this.props
    const containerClass = get(config.cta, 'show', false) ? 'with-cta' : ''
    return (
      <section
        className={`${LIVE_BOARD_CLASSNAMES.contact_card} ${containerClass} ${ACCESSIBILITY_CLASSES.main}`}
        ref={ref => this.container = ref}
        onMouseEnter={this.openSellerCard}
        onMouseLeave={this.closeSellerCard}
        onKeyDown={this.onKeyboardClick}
        tabIndex={TAB_INDEXES.SellerCard}
        style={{ width: width }}>
          <CSSTransition
            timeout={{enter: 0, exit: 500}}
            classNames='slide'
            in={isOpen}
            onExiting={this.handleOpenCardExiting}
            onEntered={this.handleOpenCardEntered}
            appear
            unmountOnExit>
            <OpenedCard
              additionalDataStyle={{ marginTop: `-${contactDetailsHeight}px` }}
              config={config}
              lead={lead}
              themeColorHex={themeColorHex}
              seller={seller}
              onCtaOpen={this.handleCtaOpen}
              onCtaClose={this.handleCtaClose} />
          </CSSTransition>
          <CSSTransition
            timeout={{enter: 500, exit: 0}}
            classNames='display'
            in={!isOpen}
            appear
            unmountOnExit>
            <ClosedCard
              config={config}
              lead={lead}
              themeColorHex={themeColorHex}
              seller={seller} />
          </CSSTransition>
      </section>
    )
  }
}

SellerCard.propTypes = {
  config: PropTypes.object.isRequired,
  lead: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  isGreetingOpen: PropTypes.bool.isRequired,
  shouldStickToTop: PropTypes.bool.isRequired,
  provideStickyContainer: PropTypes.func.isRequired
}

export default withStickiness(SellerCard)

